var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"emd-text _size_default _type_caption"},[_vm._v(" "+_vm._s(_vm.$t('charge.detail.payment-method.title'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }